// 导入组件，组件必须声明 name
import PageDetail from './src';

// 为组件提供 install 安装方法，供按需引入
PageDetail.install = function (Vue) {
    Vue.component(PageDetail.name, PageDetail)
};

// 导出组件
export default PageDetail;